// Header.js


import './styles.css';
import imagem from './images/logotipo.svg';


const Header = ({ header }) => {

  return (
    <div>
        <div className="stripes">
        <div className="first">
        <img src={imagem} alt="Logo" />
        </div>
        <div className="second">
        <p><span className="logoverde">AI</span><span className="logobranco">DATACAPTURE</span><span className="logoverde">7</span></p>
        </div>
        <div className="third">
        <p></p>
        </div>
        </div>
    </div>
  );
};

export default Header;

